import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faFileAudio } 	from '@fortawesome/free-regular-svg-icons/faFileAudio'
import { faBookmark } 	from '@fortawesome/free-regular-svg-icons/faBookmark'

/*
import { faYoutube } 	from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faSpotify } 	from '@fortawesome/free-brands-svg-icons/faSpotify';
import { faApple } 		from '@fortawesome/free-brands-svg-icons/faApple';
import { faAmazon } 	from '@fortawesome/free-brands-svg-icons/faAmazon';
*/
import { faInstagram } 	from '@fortawesome/free-brands-svg-icons/faInstagram';
// import { faMusic } 		from '@fortawesome/free-solid-svg-icons/faMusic';
import { faFacebook } 	from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faTiktok }		from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faXTwitter } 	from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faSpotify } from '@fortawesome/free-brands-svg-icons/faSpotify';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faDiscord } from '@fortawesome/free-brands-svg-icons/faDiscord';

import { Container, Row, Col, Navbar, Nav, Tab, Toast, Image, Modal, Button } from 'react-bootstrap';

// import { useTour } from './context/tour-context';
import KuulaProject from './components/KuulaProject';
// import SiteItem from './components/SiteItem';

import './styles/App.css';
import './styles/TabStyles.css';

var frame_id = 0;
const KuulaPlayerAPI = window.KuulaPlayerAPI;

const site_items = [
	{ id: 1,   hotspot_name: "001", img_loc: "001.png", title: "", description: "", visible: false },
	{ id: 2,   hotspot_name: "002", img_loc: "002.png", title: "", description: "", visible: false },
	{ id: 3,   hotspot_name: "003", img_loc: "003.png", title: "", description: "", visible: false },
	{ id: 4,   hotspot_name: "004", img_loc: "004.png", title: "", description: "", visible: false },
	{ id: 5,   hotspot_name: "005", img_loc: "005.png", title: "", description: "", visible: false },
	{ id: 6,   hotspot_name: "006", img_loc: "006.png", title: "", description: "", visible: false },
	{ id: 5,   hotspot_name: "007", img_loc: "007.png", title: "", description: "", visible: false },
	{ id: 4,   hotspot_name: "008", img_loc: "008.png", title: "", description: "", visible: false },
	{ id: 5,   hotspot_name: "009", img_loc: "009.png", title: "", description: "", visible: false },
	{ id: 6,   hotspot_name: "010", img_loc: "010.png", title: "", description: "", visible: false },
	{ id: 5,   hotspot_name: "011", img_loc: "011.png", title: "", description: "", visible: false }
]

/*
const dsp_links = [
	{
		title: 'Youtube',
		link: "https://youtube.com/subscription_center?add_user=officialalicecooper",
		icon: faYoutube,
		from: 'fontawesome'
	},
	{
		title: 'Spotify',
		link: "https://open.spotify.com/artist/3EhbVgyfGd7HkpsagwL9GS",
		icon: faSpotify,
		from: 'fontawesome'
	},
	{
		title: 'Apple Music',
		link: "https://itunes.apple.com/ca/artist/alice-cooper/393703",
		icon: faApple,
		from: 'fontawesome'
	},
	{
		title: 'Pandora',
		link: "https://www.pandora.com/artist/alice-cooper/AR3V6m4Pmrxmg9q",
		icon: faMusic,
		from: 'fontawesome'
	},
	{
		title: 'Amazon Music',
		link: "https://www.amazon.com/Alice-Cooper/e/B000AP9PB0",
		icon: faAmazon,
		from: 'fontawesome'
	}
]
*/

const socials = [
	{
		link: "https://facebook.com/coheedandcambria",
		icon: faFacebook,
		from: 'fontawesome'
	},
	{
		link: "https://twitter.com/coheed",
		icon: faXTwitter,
		from: 'fontawesome'
	},
	{
		link: "https://instagram.com/coheed",
		icon: faInstagram,
		from: 'fontawesome'
	},
	{
		link: "https://www.youtube.com/coheedandcambriaofficial",
		icon: faYoutube,
		from: 'fontawesome'
	},
	{
		link: "https://open.spotify.com/artist/3utxjLheHaVEd9bPjQRsy8?si=U4wUnd2ySMa9p5mGSfm3HQ",
		icon: faSpotify,
		from: 'fontawesome'
	},
	{
		link: "https://music.apple.com/us/artist/coheed-and-cambria/15031628",
		icon: faApple,
		from: 'fontawesome'
	},
	{
		link: "https://discord.gg/coheed",
		icon: faDiscord,
		from: 'fontawesome'
	}
]

export default function App() {

	const [ show, setShow ] = useState(true);
	const [ firstLoad, setFirstLoad ] = useState(true);

	// const [ toastShow, setToastShow ] = useState(false);
	const [ toastList, setToastList ] = useState([]);

	const [ offcanvas, setOffcanvas ] = useState('');
	const [ tabSelected, setTab ] = useState('audio');

	const [ items, setItems ] = useState([ ...site_items ]);
	const [ itemCount, setItemCount ] = useState(0);

	const [ hotspot, setSelectedHotspot ] = useState('');

	function toggleCanvas() {
		if ( offcanvas === '' )
			setOffcanvas('show')
		else 
			setOffcanvas('')
	}

	useEffect(() => {
		
		// clearFoundItems() // always start fresh / clear past tries

		if ( localStorage.getItem('cac_items') ) {
			let count = 0;
			var localEggs = JSON.parse(localStorage.getItem('cac_items'));
			var updated_items = localEggs?.map(item => {
				if (item.visible) count++;
				return item;
			})
			setItemCount(count);
			setItems([ ...updated_items ])
		}

		KuulaPlayerAPI.addEventListener("frameloaded", function(e) {
			frame_id = e.frame;
		});

		KuulaPlayerAPI.addEventListener("hotspot", function(e) {
			setSelectedHotspot(e.data.name);
		});

	}, []);

	useEffect(() => {

		if ( hotspot !== '' ) {

			// check if item clicked on
			let new_count = itemCount;
			
			var new_toast = {}
			var new_items = items.map(item => {
				if ( item.hotspot_name === hotspot && !item.visible ) {
					new_count++;
					// add item to toast list
					new_toast = {
						'id': item.id,
						'message': 'Hidden Item Found!',
						'item_name': item.title,
						'img': item.img_loc
					}
					return { ...item, visible: true }
				}
				return { ...item };  
			});

			
			if ( new_count > itemCount ) {
				setItemCount(new_count);
				setItems([ ...new_items ]);
				localStorage.setItem('cac_items', JSON.stringify(new_items))

				setToastList(prevList => ([
					...prevList,
					new_toast
				]))
			}

		}

	}, [hotspot])

	function clearFoundItems() {
		localStorage.removeItem('cac_items');
		localStorage.setItem('cac_items', JSON.stringify([ ...site_items ]));
		setItemCount(0);
		setItems([ ...site_items ]);
		setSelectedHotspot('')
	}

	function removeToastFromList(toast_id) {
		var removeItemIndex = toastList.findIndex(toast => toast.id === toast_id);
		var newToastList = [ ...toastList ];
		newToastList.splice(removeItemIndex, 1);
		setToastList(newToastList);
	}

	function handleClose() {
		setShow(false);
		if ( firstLoad ) {
			setFirstLoad(false);
		}
	}

	function showInstructions(e) {
		e.preventDefault();
		setShow(true);
	}

	return (
		<div className="App">

			<Modal show={show} onHide={handleClose}>
				<Modal.Body className="text-center">
					<div className="position-relative">
						<img src={`images/coheed-vinyl.jpg`} alt="Welcome Instructions" style={{ width: '100%' }} />
						<div className="d-flex position-absolute bottom-0 justify-content-around my-2" style={{ width: '100%' }}>
							<a href="https://coheedandcambria.lnk.to/tfomb" type="button" className="btn bg-black border border-light fw-bold my-0 mx-auto text-light fs-4"  target="_blank" rel="noopener noreferrer">
								<span style={{ whiteSpace: 'nowrap' }}>PRE-SAVE</span> / <span style={{ whiteSpace: 'nowrap' }}>PRE-ADD</span>
							</a>
							<a href="http://coheedandcambria.lnk.to/store" type="button" className="btn bg-black border border-light fw-bold my-0 mx-auto text-light fs-4" target="_blank" rel="noopener noreferrer">
								PRE-ORDER
							</a>
						</div>
					</div>
					<div className="position-relative mt-3">
						<img src={`images/welcome-banner3.png`} alt="360 Instructions" style={{ width: '100%' }} />
						<div className="d-flex position-absolute bottom-0 justify-content-around my-2" style={{ width: '100%' }}>
							<button type="button" className="btn bg-black border border-light fw-bold my-0 mx-auto text-light fs-4 mb-4" onClick={handleClose}>
								{firstLoad ? 'Enter The Experience!' : 'Close'}
							</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Navbar variant="dark" bg="transparent" fixed="bottom" expand={false} defaultExpanded={false}>
				<Navbar.Toggle className="p-0 border-0" data-toggle="offcanvas" onClick={toggleCanvas} />
				<Navbar.Collapse id="offcanvas_navigation">
					<Tab.Container activeKey={tabSelected} onSelect={(k) => setTab(k)}>
					<Container>
						<Row id="tour-title-row">
							<Col className="text-center">
								<div className="d-flex justify-content-around mt-2 ms-0">
									{socials.map((social, idx) => (
										<div key={idx}>
											{social.from === 'fontawesome' ? (
												<a href={social.link} target="_blank" className="d-block text-white" rel="noreferrer">
													<FontAwesomeIcon icon={social.icon} height={"20px"} className="mx-2" />
												</a>
											) : (
												<a href={social.link} target="_blank" className="d-block text-white" rel="noreferrer">
													<Image className="mx-4" src={social.icon} alt="icon" width={20} height={20} />
												</a>
											)}
										</div>
									))}
								</div>
								<img src={`images/Coheed-Main.png`} alt="Coheed and Cambria" style={{ width: '150px' }} className="rounded my-4" />
							</Col>
						</Row>
						<Row id="tab-row">
							<Col>
								<Nav justify variant="tabs" defaultActiveKey="audio" style={{ flexDirection: 'row', maxWidth: '400px' }}>
									<Nav.Item>
										<Nav.Link eventKey="audio">
											<FontAwesomeIcon icon={faFileAudio} />
										</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="items">
											<FontAwesomeIcon icon={faBookmark} className="me-2" /><span id="items_found">{itemCount}</span> / <span id="items_total">{items.length}</span>
										</Nav.Link>
									</Nav.Item>
								</Nav>
							</Col>
						</Row>
						<Row style={{ margin: 0 }}>
							<Col>
								<Tab.Content>
									<Tab.Pane transition={false} eventKey="audio">
										<iframe title="spotify-player" style={{ border: 'none', marginTop: '20px' }} src="https://open.spotify.com/embed/album/7t914q200AnbbeomCdJU9L?utm_source=generator"
											width="100%" height="352" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
										{/*
										<div>
											{dsp_links.map((dsp, idx) => (
												<div key={idx}>
													{dsp.from === 'fontawesome' ? (
														<a href={dsp.link} target="_blank" className="d-block text-white border border-light rounded-lg py-2 my-3 text-decoration-none" rel="noreferrer">
															<FontAwesomeIcon icon={dsp.icon} height={"25px"} className="mx-4" /> {dsp.title}
														</a>
													) : (
														<a href={dsp.link} target="_blank" className="d-block text-white text-decoration-none" rel="noreferrer">
															<Image className="mx-4" src={dsp.icon} alt="icon" width={20} height={20} />
														</a>
													)}
												</div>
											))}
										</div>
										*/}
									</Tab.Pane>
									<Tab.Pane transition={false} eventKey="items">
										{items.length && (
											<>
												<div className="tab-pane-instr text-center">
													Can you find all the Hidden Items?<br /> Clicking the items in the 360 viewer will reveal them here.
													{itemCount > 0 && (
														<div>
															[ <span style={{ fontSize: '.8em', color: '#FFFFFF', cursor: 'pointer' }} onClick={() => { clearFoundItems() }}>Clear Found Items</span> ]
														</div>
													)}
												</div>
											</>
										)}
										<div id="items">
											<Row>
												{items?.map((item, idx) => 
													item.visible ? (
														<Col key={idx} xs={6} sm={4}>
															<Image key={item.id.toString()} id={`item_${item.id}`} src={`images/items/${item.img_loc}`} alt="found item" className="item_thumb" title={item.title} fluid />
														</Col>
													) : (
														<Col key={idx} xs={6} sm={4}>
															<Image key={item.id.toString()} id={`item_${item.id}`} src={`images/hidden-item.png`} alt="hidden item" className="item_thumb" title={'Hidden Item'} fluid />
														</Col>
													)
												)}
											</Row>
										</div>
									</Tab.Pane>
								</Tab.Content>
							</Col>
						</Row>
					</Container>
					</Tab.Container>
				</Navbar.Collapse>
			</Navbar>
			
			<div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: '1000' }}>
				{toastList?.map(toast => {
					return (
						<Toast key={toast.id} onClose={() => removeToastFromList(toast.id)} show={true} delay={7000} autohide>
							<Toast.Header>
								<FontAwesomeIcon icon={faBookmark} className="me-3" />
								<strong className="mx-auto">{toast.message}</strong>
							</Toast.Header>
							<Toast.Body style={{ textAlign: 'left' }}>
								<img src={'images/items/' +toast.img} className="rounded me-2" style={{ height: '50px', width: '50px' }} alt="" />
								{toast.item_name}
							</Toast.Body>
						</Toast>
					)
				})}
			</div>

			<KuulaProject />
		</div>
	)
}